import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Tooth = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="tooth icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 22 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.4697 3.38796C20.2704 1.26674 18.0557 0 15.5492 0C13.9555 0 12.5159 0.868094 10.9061 0.815322C9.34813 0.781813 7.92269 0 6.30867 0C3.88668 0 1.72485 1.26674 0.52517 3.38796C-0.474567 5.15844 -0.0913069 9.06297 2.05788 11.8347C3.14079 13.2317 3.68474 16.0732 3.68474 17.2705C3.68474 19.5964 4.45162 23.6831 7.48607 23.6831C9.55273 23.6831 9.42778 21.5266 9.31753 20.0619C9.20808 18.6033 8.79536 17.2184 9.5 16C9.72934 15.6026 10.1087 14.9794 10.8043 14.9897C11.5 15 11.7978 15.1328 12.0506 15.5697C12.7749 16.8237 12.6847 18.6787 12.6115 20.1695C12.5349 21.7617 12.5747 24 14.756 24C17.5173 24 18.5454 19.891 18.5454 17.8045C18.5454 16 19 13.5 19.9543 11.8347C21.6945 8.79809 22.4728 5.16272 21.4697 3.38796Z"
    />
  </svg>
)
